import {
  NumberInputProps,
  SelectOption,
  ValidatedFieldProps,
  Widget,
} from '@kanda-libs/ks-component-ts';

import { AddressFieldType } from '..';

export const MONTHS_AT_ADDRESS_BASE_FIELDNAMES: Record<
  AddressFieldType,
  string
> = {
  current: 'credit.customer_details.current_address.months_at_address',
  previous1: 'credit.customer_details.previous_address_one.months_at_address',
  previous2: 'credit.customer_details.previous_address_two.months_at_address',
};

export const YEARS_AT_ADDRESS_INDEXES: Record<AddressFieldType, number> = {
  current: 0,
  previous1: 1,
  previous2: 2,
};

export const ERROR_PROPS = {
  label: {
    required: 'You must provide the date you moved into this address',
    inPast: 'The date provided must be in the past',
    beforePrevAddress:
      'The date you moved in must be before the previous address',
  },
  className: 'text-style-h text-red-200 -mt-4 mb-6',
};

export const BASE_WIDGET: Record<
  AddressFieldType,
  (props: ValidatedFieldProps<NumberInputProps>) => JSX.Element
> = {
  current: Widget.CreditCustomerDetailsCurrentAddressMonthsAtAddress,
  previous1: Widget.CreditCustomerDetailsPreviousAddressOneMonthsAtAddress,
  previous2: Widget.CreditCustomerDetailsPreviousAddressTwoMonthsAtAddress,
};

export const MONTHS_OPTIONS: SelectOption[] = [
  {
    name: 'Jan',
    value: '0',
  },
  {
    name: 'Feb',
    value: '1',
  },
  {
    name: 'Mar',
    value: '2',
  },
  {
    name: 'Apr',
    value: '3',
  },
  {
    name: 'May',
    value: '4',
  },
  {
    name: 'Jun',
    value: '5',
  },
  {
    name: 'Jul',
    value: '6',
  },
  {
    name: 'Aug',
    value: '7',
  },
  {
    name: 'Sep',
    value: '8',
  },
  {
    name: 'Oct',
    value: '9',
  },
  {
    name: 'Nov',
    value: '10',
  },
  {
    name: 'Dec',
    value: '11',
  },
];
